import React, { useEffect, useState } from 'react';

import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../../Auth';
import { useAxios } from '../../../../../AxiosHandler';
import { general } from '../../../../../general';
import { Accordion } from 'react-bootstrap';

import styles from './DogHistory.module.scss';

function DogHistory(props: DogHistoryProps) {
    const t = useTranslate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;

    const [historyRelationshipValue, setHistoryRelationshipValue] = useState<Array<any>>([]);
    const [historyHDIndexData, setHistoryHDIndexData] = useState<Array<any>>([]);
    const [historyBreedingValuesLeash, setHistoryBreedingValuesLeash] = useState<Array<any>>([]);
    const [historyBreedingValuesLoose, setHistoryBreedingValuesLoose] = useState<Array<any>>([]);

    function hasData() {
        return (
            historyRelationshipValue?.length > 0 ||
            historyHDIndexData?.length > 0 ||
            historyBreedingValuesLeash?.length > 0 ||
            historyBreedingValuesLoose?.length > 0
        )
    }

    function roundToTwo(num: number) {
        return Math.round((num + Number.EPSILON) * 100) / 100;
    }

    function getAccuracyColor(accuracy: number) {
        let color = "#e1e855";
    
        if (accuracy > 0.6) {
            return color = "#68DB5A"; // Green
        } else if (accuracy > 0.3) {
            return color =  "#e1e855"; // Yellow
        } else {
            return color =  "#e16a6a"; // Red
        }
    }

    function getHistoryRelationshipValue(dogId: string | undefined = props.dogId) {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + dogId + "/history/relationshipvalue",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res: any) => {
            setHistoryRelationshipValue(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getHistoryHDIndexData(dogId: string | undefined = props.dogId) {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + dogId + "/history/hdindex",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res: any) => {
            setHistoryHDIndexData(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getHistoryBreedingValuesLeash(dogId: string | undefined = props.dogId) {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + dogId + "/history/breedingvaluesleash",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res: any) => {
            setHistoryBreedingValuesLeash(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getHistoryBreedingValuesLoose(dogId: string | undefined = props.dogId) {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + dogId + "/history/breedingvaluesloose",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res: any) => {
            setHistoryBreedingValuesLoose(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    useEffect(() => {
        if (props.dogId != undefined && auth.selectedCountry != undefined) {
            getHistoryRelationshipValue(props.dogId);
            getHistoryHDIndexData(props.dogId);
            getHistoryBreedingValuesLeash(props.dogId);
            getHistoryBreedingValuesLoose(props.dogId);
        }
    }, [auth.selectedCountry, props.dogId]);

    useEffect(() => {
        if (props.onDataLoaded != undefined) {
            props.onDataLoaded(hasData());
        }
    }, [
        historyRelationshipValue,
        historyHDIndexData,
        historyBreedingValuesLeash,
        historyBreedingValuesLoose
    ]);

    return (
        <div className={styles.doghistory}>
            { hasData() ?
                <Accordion className={styles.accordion}>
                    { historyHDIndexData?.length > 0 ?
                        <Accordion.Item
                            className={styles.accordionitem}
                            eventKey="01"
                        >
                            <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.history.hdindex.title")}</Accordion.Header>
                            <Accordion.Body>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{t("dog.statistics.areas.history.hdindex.columns.date")}</th>
                                            <th>{t("dog.statistics.areas.history.hdindex.columns.index")}</th>
                                            <th>{t("dog.statistics.areas.history.hdindex.columns.accuracy")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {historyHDIndexData?.map((data: any, index: number) => 
                                            <tr key={index}>
                                                <td>{general.dateToString(new Date(data.DATO))}</td>
                                                <td>{data.HD_INDEX}</td>
                                                <td>{roundToTwo(data.SIKKERHET)}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </Accordion.Body>
                        </Accordion.Item>
                    : null }
                    { historyBreedingValuesLeash?.length > 0 ?
                        <Accordion.Item
                            className={styles.accordionitem}
                            eventKey="02"
                        >
                            <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.history.breedingvaluesleash.title")}</Accordion.Header>
                            <Accordion.Body>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesleash.columns.date")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesleash.columns.M1")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesleash.columns.M2")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesleash.columns.M3")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesleash.columns.M4")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesleash.columns.M5")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {historyBreedingValuesLeash?.map((data: any, index: number) => 
                                            <tr key={index}>
                                                <td>{general.dateToString(new Date(data.DATO))}</td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M1), fontWeight: "bold" }}>{data.M1}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M2), fontWeight: "bold" }}>{data.M2}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M3), fontWeight: "bold" }}>{data.M3}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M4), fontWeight: "bold" }}>{data.M4}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M5), fontWeight: "bold" }}>{data.M5}</span></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <div
                                    className={styles.legend}
                                >
                                    <p>{t("dog.statistics.areas.history.breedingvaluesleash.columns.M1")}: {t("dog.statistics.areas.history.breedingvaluesleash.keys.M1")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesleash.columns.M2")}: {t("dog.statistics.areas.history.breedingvaluesleash.keys.M2")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesleash.columns.M3")}: {t("dog.statistics.areas.history.breedingvaluesleash.keys.M3")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesleash.columns.M4")}: {t("dog.statistics.areas.history.breedingvaluesleash.keys.M4")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesleash.columns.M5")}: {t("dog.statistics.areas.history.breedingvaluesleash.keys.M5")}</p>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    : null }
                    { historyBreedingValuesLoose?.length > 0 ?
                        <Accordion.Item
                            className={styles.accordionitem}
                            eventKey="03"
                        >
                            <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.history.breedingvaluesloose.title")}</Accordion.Header>
                            <Accordion.Body>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.date")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M1")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M2")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M3")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M4")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M5")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M6")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M7")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M8")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M9")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M10")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M10A")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M10B")}</th>
                                            <th>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M10C")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {historyBreedingValuesLoose?.map((data: any, index: number) => 
                                            <tr key={index}>
                                                <td>{general.dateToString(new Date(data.DATO))}</td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M1), fontWeight: "bold" }}>{data.M1}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M2), fontWeight: "bold" }}>{data.M2}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M3), fontWeight: "bold" }}>{data.M3}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M4), fontWeight: "bold" }}>{data.M4}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M5), fontWeight: "bold" }}>{data.M5}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M6), fontWeight: "bold" }}>{data.M6}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M7), fontWeight: "bold" }}>{data.M7}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M8), fontWeight: "bold" }}>{data.M8}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M9), fontWeight: "bold" }}>{data.M9}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M10), fontWeight: "bold" }}>{data.M10}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M10A), fontWeight: "bold" }}>{data.M10A}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M10B), fontWeight: "bold" }}>{data.M10B}</span></td>
                                                <td><span style={{ color: getAccuracyColor(data.SIKKERHET_M10C), fontWeight: "bold" }}>{data.M10C}</span></td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <div
                                    className={styles.legend}
                                >
                                    <p>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M1")}: {t("dog.statistics.areas.history.breedingvaluesloose.keys.M1")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M2")}: {t("dog.statistics.areas.history.breedingvaluesloose.keys.M2")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M3")}: {t("dog.statistics.areas.history.breedingvaluesloose.keys.M3")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M4")}: {t("dog.statistics.areas.history.breedingvaluesloose.keys.M4")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M5")}: {t("dog.statistics.areas.history.breedingvaluesloose.keys.M5")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M6")}: {t("dog.statistics.areas.history.breedingvaluesloose.keys.M6")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M7")}: {t("dog.statistics.areas.history.breedingvaluesloose.keys.M7")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M8")}: {t("dog.statistics.areas.history.breedingvaluesloose.keys.M8")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M9")}: {t("dog.statistics.areas.history.breedingvaluesloose.keys.M9")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M10")}: {t("dog.statistics.areas.history.breedingvaluesloose.keys.M10")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M10A")}: {t("dog.statistics.areas.history.breedingvaluesloose.keys.M10A")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M10B")}: {t("dog.statistics.areas.history.breedingvaluesloose.keys.M10B")}</p>
                                    <p>{t("dog.statistics.areas.history.breedingvaluesloose.columns.M10C")}: {t("dog.statistics.areas.history.breedingvaluesloose.keys.M10C")}</p>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    : null }
                    { historyRelationshipValue?.length > 0 ?
                        <Accordion.Item
                            className={styles.accordionitem}
                            eventKey="04"
                        >
                            <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.history.relationshipvalue.title")}</Accordion.Header>
                            <Accordion.Body>
                                <table className="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>{t("dog.statistics.areas.history.relationshipvalue.columns.date")}</th>
                                            <th>{t("dog.statistics.areas.history.relationshipvalue.columns.value")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {historyRelationshipValue?.map((data: any, index: number) => 
                                            <tr key={index}>
                                                <td>{general.dateToString(new Date(data.DATO))}</td>
                                                <td>{data.SLEKTSKAPSVERDI}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </Accordion.Body>
                        </Accordion.Item>
                    : null }
                </Accordion>
            : null }
        </div>
    );
}

class DogHistoryProps {
    dogId?: string;
    onDataLoaded?: Function;
}

export default DogHistory;
